import { render, staticRenderFns } from "./TabGsheets.vue?vue&type=template&id=77def05c&"
import script from "./TabGsheets.vue?vue&type=script&lang=js&"
export * from "./TabGsheets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports